import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';
import { useAuth0 } from '../../../context/auth0';

import { Modal } from './../Modal';
import { ModalClose } from './../ModalClose';

import Form from './form';

import auth0 from 'auth0-js';
import {
  logBrazeAccountRegistration,
  queueBrazeEmailSubscriptionAfterSignup,
  setBrazeAuthMethod,
} from '../../../command/braze';
import {
  trackNewsletterConsentRecorded,
  NEWSLETTER_SOURCES,
} from '../../../utils/posthogTracking';

const webAuth = new auth0.WebAuth({
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientID: process.env.REACT_APP_AUTH0_CLIENT_ID,
  audience: process.env.REACT_APP_AUTH0_AUDIENCE,
  scope: 'openid profile email',
  redirectUri: window.location.origin,
  responseType: 'token',
});

const cookies = new Cookies();

const ModalOneTap = (props) => {
  var welfareUser = cookies.get('welfare_user') ?? null;
  var cdsUser = document.body.classList.contains('affiliate-cds');
  const hasProvider = cdsUser || welfareUser;
  const distanceInRem = props.hasBanner ? 3 : (hasProvider ? 1.688 : 0)

  const [isModalOpen, setIsModalOpen] = useState(null);
  const [hasChecked, setHasChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated } = useAuth0();
  const [errors, setErrors] = useState(null);
  const [hasBanner, setHasBanner] = useState(distanceInRem);

  const positionAbsolute =
    window.location.href.includes(app_main_wpml.product_directory) &&
    window.innerWidth > 1024;

  useEffect(() => {
    const checkAndOpenModal = () => {
      if (
        checkIubenda() &&
        checkLocation() &&
        checkLoggedIn() &&
        checkSession() &&
        checkUserNotTyping()
      ) {
        setIsModalOpen(true);
        setHasChecked(true);
        localStorage.setItem('presentedOneTap', new Date().toISOString());
      }
    };

    let intervalId = null;
    if (isModalOpen === null && !hasChecked) {
      intervalId = setInterval(() => {
        checkAndOpenModal();
      }, 7 * 1000);
    }

    return () => {
      if (typeof intervalId !== 'undefined' && intervalId != null) {
        clearInterval(intervalId);
      }
    };
  }, [hasChecked]);

  const checkLocation = () => {
    return (
      !window.location.href.includes('checkout') &&
      !window.location.href.includes('my-orders') &&
      !window.location.href.includes('prenotazioni') &&
      !window.location.href.includes('team-building')
    );
  };

  const checkSession = () => {
    let presentedOneTap = localStorage.getItem('presentedOneTap');
    const now = new Date();
    if (presentedOneTap === null) {
      return true;
    }
    presentedOneTap = new Date(presentedOneTap);
    const timeDifference = now - presentedOneTap;
    const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
    const olderThanOneDay = timeDifference > oneDayInMilliseconds;

    if (!olderThanOneDay) {
      setHasChecked(true);
    }

    return olderThanOneDay;
  };

  const checkLoggedIn = () => {
    return !isAuthenticated;
  };

  const checkIubenda = () => {
    const iubendaElements = document.querySelectorAll('.iubenda-cs-container');
    const isIubendaPresent = iubendaElements.length > 0;

    return !isIubendaPresent;
  };

  const checkUserNotTyping = () => {
    const activeElement = document.activeElement;

    if (
      activeElement &&
      (activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.contentEditable === 'true' ||
        activeElement.contentEditable === true)
    ) {
      return false;
    }

    return true;
  };

  const onSubmit = ({ email, password, privacy, newsletter, ...values }) => {
    setIsLoading(true);
    cookies.set('target_url', window.location.pathname, { path: '/' });

    if ('first_name' in values && !('last_name' in values)) {
      const splitIndex = values.first_name.indexOf(' ');
      if (splitIndex === -1) {
        values.last_name = '';
      } else {
        values.last_name = values.first_name.substring(splitIndex + 1);
        values.first_name = values.first_name.substring(0, splitIndex);
      }
    }

    webAuth.signupAndAuthorize(
      {
        connection: 'DB-wpdbfreedomeit',
        email: email,
        password: password,
        user_metadata: {
          ...values,
          privacy: 'true',
          newsletter: newsletter ? 'true' : 'false',
        },
      },
      function (registerErr, registerResult) {
        if (registerErr) {
          if (registerErr.code === 'user_exists') {
            registerErr = null;
            webAuth.login(
              {
                email: email,
                password: password,
                realm: 'DB-wpdbfreedomeit',
              },
              (loginError, loginResult) => {
                if (loginError) {
                  setErrors(loginError);
                } else {
                  registerResult = loginResult;
                }
              }
            );
          }
          setErrors(registerErr);
        }
        // TODO: add cookie expiration, the code below seems not working
        // expires: new Date(Date.now() + (authResult.expiresIn * 1000)), httpOnly: true,
        cookies.set('auth0_token', registerResult.accessToken, { path: '/' });

        // PostHog sends the events in its queue before the reload.
        trackNewsletterConsentRecorded(
          !!newsletter,
          NEWSLETTER_SOURCES.ONE_TAP_MODAL
        );

        // Apply this choice after reload, once Braze has identified the account.
        queueBrazeEmailSubscriptionAfterSignup(email, newsletter);
        logBrazeAccountRegistration('email_password', 'menu');
        setBrazeAuthMethod('email_password');

        location.reload();

        setIsLoading(false);
        setIsSuccess(true);
      }
    );
  };

  const auth0Google = () => {
    cookies.set('target_url', window.location.pathname, { path: '/' });
    webAuth.authorize({
      connection: 'google-oauth2',
    });
  };

  const auth0Facebook = () => {
    cookies.set('target_url', window.location.pathname, { path: '/' });
    webAuth.authorize({
      connection: 'facebook',
    });
  };

  const auth0Apple = () => {
    cookies.set('target_url', window.location.pathname, { path: '/' });
    webAuth.authorize({
      connection: 'apple',
    });
  };

  useEffect(() => {
    if (!distanceInRem) return;

    const handleScroll = () => {
      if (window.scrollY > 20) {
        setHasBanner(distanceInRem);
      } else {
        setHasBanner(distanceInRem);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  const modal = (
    <Modal
      onClickOverlay={() => setIsModalOpen(false)}
      isOpen={isModalOpen ?? false}
      isOneTap={true}
      allowScroll={true}
      shouldScroll={false}
      noBlur={true}
      extraMargin={hasBanner}
    >
      <div className="one-tap__signup">
        <ModalClose onClick={() => setIsModalOpen(false)} />
        <Form
          onSubmit={onSubmit}
          auth0Google={auth0Google}
          formErrors={!!errors}
          auth0Facebook={auth0Facebook}
          auth0Apple={auth0Apple}
        />
      </div>
    </Modal>
  );

  return <React.Fragment>{modal}</React.Fragment>;
};

export { ModalOneTap };
